export default {
  name: 'KCol',
  props: {
    weight: {
      type: Number,
      default: 24,
    },
    tag: {
      type: String,
      default: 'div',
    },
    offset: Number,
    pull: Number,
    push: Number,
  },
  computed: {
    gutter() {
      let parent = this.$parent
      while (parent && parent.$options.componentName !== 'KRow') {
        parent = parent.$parent
      }
      return parent ? parent.gutter : 0
    },
  },
  render(h) {
    const classList = []
    const style = {}

    if (this.gutter) {
      style.paddingLeft = this.gutter / 2 + 'px'
      style.paddingRight = style.paddingLeft
    }

    ;['weight', 'offset', 'pull', 'push'].forEach(prop => {
      if (this[prop] || this[prop] === 0) {
        classList.push(prop !== 'weight' ? `km-col-${prop}-${this[prop]}` : `km-col-${this[prop]}`)
      }
    })

    return h(
      this.tag,
      {
        staticClass: 'km-col',
        class: classList,
        style,
      },
      this.$slots.default,
    )
  },
}
